export default {
  SET_USERNAME: "SET_USERNAME",
  SET_USERID:"SET_USERID",
  SET_PROJECTID: "SET_PROJECTID",
  SET_PROJECTNAME: "SET_PROJECTNAME",
  SET_parm_country: "parm_country",
  SET_parm_brand: "parm_brand",
  setloginusername(loginusername) {
    localStorage.setItem("SET_USERNAME", loginusername);
  },
  getloginusername() {
    return localStorage.getItem("SET_USERNAME");
  },
  getloginuserid() {
    return localStorage.getItem("SET_USERID");
  },
  setProjectName(projectname) {
    localStorage.setItem("SET_PROJECTNAME", projectname);
  },
  getProjectName() {
    return localStorage.getItem("SET_PROJECTNAME");
  },
  setProjectID(projectname) {
    localStorage.setItem("SET_PROJECTID", projectname);
  },
  getProjectID() {
    if(localStorage.getItem("SET_PROJECTID") == null){
      return 0;
    }else{
      return localStorage.getItem("SET_PROJECTID");
    }
   
  },
  setcurrentstep(stepid) {
    localStorage.setItem("SET_STEPID", stepid);
  },
  getcurrentstep() {
    return localStorage.getItem("SET_STEPID");
  },
  RemoveProjectfromStorage() {
    localStorage.removeItem(this.SET_PROJECTNAME);
    localStorage.removeItem(this.SET_PROJECTID);
    // alert('d');
  },
  setcountry(country) {
    localStorage.setItem(this.SET_parm_country, country);
  },
  getcountry() {
    return localStorage.getItem(this.SET_parm_country);
  },
  setbrand(brand) {
    localStorage.setItem(this.SET_parm_brand, brand);
  },
  getbrand() {
    return localStorage.getItem(this.SET_parm_brand);
  },
};
